/* ============================================================
   PHREE SKIN — HOME page behaviour.
   Owns two things motion.js can't do generically:
   (1) the Seed two-product ENTER MOTION — the card ::before panel
       grows scaleY .9→1 while the product media swells 1→1.14, both
       0.3s, fired together on IntersectionObserver, per-card stagger.
   (2) the immersive DRAGGABLE carousel — pointer-drag with momentum
       + grab/grabbing, scroll-snap suspended mid-drag.
   Runs BEFORE motion.js; claims the .pcard[data-lift] islands so the
   generic [data-lift] in motion.js skips them (no double-fire).
   Respects reduced-motion.
   ============================================================ */
(function () {
  "use strict";
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* expose the real nav height (the transparent bar only, NOT the solid
     announce strip) so the hero can tuck up under just the nav ------- */
  function measureNav() {
    var nav = document.getElementById("nav");
    /* ceil the fractional height so the hero always pulls fully up under the nav
       (offsetHeight rounds down → a 1px white seam under the announce bar). */
    var h = nav ? Math.ceil(nav.getBoundingClientRect().height) : 82;
    document.documentElement.style.setProperty("--nav-h", h + "px");
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", measureNav);
  else measureNav();
  window.addEventListener("load", measureNav);
  window.addEventListener("resize", measureNav, { passive: true });

  /* (hero + film-band video source/playback is handled site-wide in app.js) */

  /* ── (1) TWO-PRODUCT LIFT-CARDS ──────────────────────────────── */
  var cards = Array.prototype.slice.call(document.querySelectorAll(".pcard[data-lift]"));
  cards.forEach(function (c) { c.setAttribute("data-lift-owned", ""); });  // tell motion.js to skip

  if (!reduce && cards.length) {
    cards.forEach(function (card) {
      var panel = card.querySelector(".pcard__panel");
      var media = card.querySelector(".lift__media");
      /* rest state: photo slightly over-scaled; it SETTLES to 1 on enter (Seed
         "product eases into place"). panel kept null-safe for any legacy card. */
      if (panel) { panel.style.transformOrigin = "center center"; panel.style.transform = "scaleY(0.9)"; panel.style.transition = "transform 0.6s var(--e-out)"; }
      if (media) { media.style.transformOrigin = "center center"; media.style.transform = "scale(1.12)"; media.style.transition = "transform 0.9s cubic-bezier(.16,1,.3,1)"; }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var card = en.target, i = cards.indexOf(card);
        var panel = card.querySelector(".pcard__panel");
        var media = card.querySelector(".lift__media");
        setTimeout(function () {                       // per-card stagger (Seed ~40–120ms)
          if (panel) panel.style.transform = "scaleY(1)";
          if (media) media.style.transform = "scale(1)";      // settle the photo into the frame
        }, i * 110);
        io.unobserve(card);
      });
    }, { threshold: 0.28, rootMargin: "0px 0px -8% 0px" });
    cards.forEach(function (c) { io.observe(c); });
  } else {
    cards.forEach(function (card) {
      var media = card.querySelector(".lift__media");
      if (media) media.style.transform = "scale(1)";
    });
  }

  /* ── (2) DRAGGABLE CAROUSEL ──────────────────────────────────── */
  document.querySelectorAll("[data-drag]").forEach(function (track) {
    var down = false, moved = false, startX = 0, startScroll = 0;
    var lastX = 0, lastT = 0, vel = 0, momentum = 0;

    function begin(x) {
      down = true; moved = false;
      startX = lastX = x; startScroll = track.scrollLeft;
      lastT = performance.now(); vel = 0;
      cancelAnimationFrame(momentum);
      track.classList.add("is-dragging");
    }
    function move(x) {
      if (!down) return;
      var dx = x - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
      var now = performance.now(), dt = now - lastT || 16;
      vel = (x - lastX) / dt;                 // px per ms
      lastX = x; lastT = now;
    }
    function end() {
      if (!down) return;
      down = false;
      /* momentum glide — KEEP scroll-snap suspended (is-dragging) until the glide
         settles, else snap fights the glide every frame → the "huge jitter". */
      var v = vel * 16;                        // per-frame
      if (Math.abs(v) < 0.4) { track.classList.remove("is-dragging"); return; }
      (function glide() {
        if (Math.abs(v) < 0.5) { track.classList.remove("is-dragging"); return; }
        track.scrollLeft -= v; v *= 0.94;      // friction
        momentum = requestAnimationFrame(glide);
      })();
    }

    /* Pointer events (mouse + touch unified) */
    track.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      begin(e.clientX);
    });
    track.addEventListener("pointermove", function (e) { if (down) { move(e.clientX); e.preventDefault(); } }, { passive: false });
    window.addEventListener("pointerup", end);
    track.addEventListener("pointercancel", end);
    /* swallow the click that follows a real drag so tiles don't navigate */
    track.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    /* keep native touch scroll for vertical intent; horizontal handled above */
    track.addEventListener("dragstart", function (e) { e.preventDefault(); });
  });
})();
